import React from 'react';
import { useRegistrationForm } from './core/RegistrationFormProvider';

const Timer = () => {
    const { timeLeft, formatTime } = useRegistrationForm();

    return (
        <div className="text-right">
            <span className="text-lg font-semibold">
                יש לכם {formatTime(timeLeft)} כדי להשלים את הרישום
            </span>
        </div>
    );
};

export default Timer; 